import React, { FC, useEffect, useState } from 'react';
import { BeneficiariesPresenter } from '@presenters/screens/beneficiaries.presenter';
import AEAGrid from '../../../ui/aea-grid/aea-grid';

const Beneficiaries: FC<any> = () => {

    const [dataColumns, setDataColumns] = useState([]);
    const [dataSource, setDataSource] = useState([])

    const presenter = new BeneficiariesPresenter({
        state:{
            dataColumns: dataColumns,
            dataSource: dataSource,
            setDataColumns:setDataColumns,
            setDataSource:setDataSource
        }
    });

    useEffect(() => {       
        presenter.initialize();
    }, []);

    useEffect(() => {       
        if(presenter.currentLabels && presenter.BudgetsData && presenter.params && Object.keys(presenter?.params)?.length && presenter.formMasters) presenter.initReport();
    }, [presenter.currentLabels, presenter.BudgetsData, presenter.params, presenter.formMasters]);

    return (
        <div className="container" style={{margin: "10px auto"}}>            
            <AEAGrid
                dataGridOptions={presenter.options}>
            </AEAGrid>
        </div>
    )
}

export default Beneficiaries;